import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_4.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/employee_engagement');
  const shareText = encodeURIComponent(' Boost employee engagement with recognition programs, open communication, and growth opportunities to create a thriving, outstanding workplace culture!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Employee Engagement — Outstanding Workplaces</title>
        <meta property="og:title" content="Employee Engagement — Outstanding Workplaces" />
        <meta property="og:description" content="Boost employee engagement with recognition programs, open communication, and growth opportunities to create a thriving, outstanding workplace culture" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777893561/i_4_fbooes.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/employee_engagement" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Employee Engagement — Outstanding Workplaces" />
        <meta name="twitter:description" content="Boost employee engagement with recognition programs, open communication, and growth opportunities to create a thriving, outstanding workplace culture" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777893561/i_4_fbooes.jpg" />
      </Helmet>

      <div className="sight_4_page_wrapper">
      <div className="sight_4_content_container">

        <div className="sight_4_section_one">

          {/* TITLE */}
          <h1 className="sight_4_page_title">
            Boost employee engagement with recognition programs, open communication, and growth opportunities to create a thriving, outstanding workplace culture
          </h1>

          {/* ROW */}
          <div className="sight_4_row">

            {/* LEFT SIDE */}
            <div className="sight_4_left">
              <div className="sight_4_image_wrapper">
                <img
                  src="/assets/i_4.jpg"
                  alt="Team meeting discussion"
                  className="sight_4_blog_image"
                />
              </div>


              <div className="sight_4_share_section">
                <span className="sight_4_share_text">Share :</span>
                <div className="sight_4_social_icons">
                 <img
                      src="/assets/Twitter_1.png"
                      className="sight_4_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_4_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_4_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_4_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />
                </div>
              </div>

             <p className="sight_4_intro_paragraph">
                Fostering an outstanding workplace starts with engaged employees. Key strategies include recognizing achievements, encouraging open communication, providing growth opportunities, promoting work-life balance, and involving teams in decision-making. A culture built on trust, appreciation, and collaboration not only boosts morale but drives performance, innovation, and long-term organizational success.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_4_right">
              <div className="sight_4_ad_card">
                <img src="/assets/bc_1.png" className="sight_4_ad_bg" />
                <div className="sight_4_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_4_ad_badge" />

                <div className="sight_4_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_4_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_4_section">

          <div className="sight_4_topics">

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">The Role of Employee Engagement in Creating a Thriving Workplace Culture</h2>
              <ul className="sight_4_topic_list">
                <li>Explore how active engagement fosters collaboration, motivation, and a sense of purpose, transforming workplaces into outstanding environments. Include real-world examples of organizations excelling in this area.</li>
              </ul>
            </div>

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">Top 5 Employee Engagement Strategies That Truly Work</h2>
              <ul className="sight_4_topic_list">
                <li>Highlight actionable strategies such as recognition programs, flexible work policies, feedback loops, wellness initiatives, and growth opportunities to increase engagement.</li>
              </ul>
            </div>
            
            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">Recognition and Rewards: Fueling Motivation and Retention</h2>
              <ul className="sight_4_topic_list">
                <li>Dive deep into how recognition programs, peer-to-peer appreciation, and reward systems drive employee satisfaction and loyalty, shaping a high-performance culture.</li>
              </ul>
            </div>

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">The Power of Transparent Communication in Employee Engagement</h2>
              <ul className="sight_4_topic_list">
                <li>Explain how open, honest, and consistent communication channels build trust and engagement, making employees feel heard and valued.</li>
              </ul>
            </div>

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">
                ⁠Employee Development Programs for Long-Term Engagement
              </h2>
              <ul className="sight_4_topic_list">
                <li>Focus on skill development, mentoring, training, and career growth opportunities as strategies to enhance engagement and cultivate a culture of continuous learning.</li>
              </ul>
            </div>

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">Wellness and Wellbeing: A Core Component of Engagement</h2>
              <ul className="sight_4_topic_list">
                <li>Show how physical, mental, and emotional well-being initiatives strengthen engagement, reduce burnout, and foster a supportive workplace culture.</li>
              </ul>
            </div>

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">Building a Culture of Feedback: Continuous Improvement Through Engagement</h2>
              <ul className="sight_4_topic_list">
                <li>Explore implementing regular feedback mechanisms, surveys, and open-door policies to keep employees actively involved in shaping workplace culture.</li>
              </ul>
            </div>

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">Team-Building Activities That Actually Engage Employees</h2>
              <ul className="sight_4_topic_list">
                <li>Highlight creative team-building exercises, collaborative projects, and cross-functional initiatives that enhance camaraderie and engagement.</li>
              </ul>
            </div>

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">Technology-Driven Engagement: Tools and Platforms That Work</h2>
              <ul className="sight_4_topic_list">
                <li>Discuss modern engagement tools such as employee apps, gamification, recognition platforms, and virtual collaboration tools that promote interaction and inclusion.</li>
              </ul>
            </div>

            <div className="sight_4_topic_item">
              <h2 className="sight_4_topic_heading">Measuring Engagement: Key Metrics for Outstanding Workplaces</h2>
              <ul className="sight_4_topic_list">
                <li>Provide guidance on tracking engagement through metrics like eNPS (employee Net Promoter Score), turnover rates, participation levels, and satisfaction surveys to continuously improve culture.</li>
              </ul>
            </div>

          </div>
        </div>

      </div>
   </div>
    </>
  );
}

export default BlogPage;

